import { useCallback, useState } from 'react';
import type { Food, KairaRequest, KairaResponse, Targets } from '../types';

/** Per-option KAIRA is deferred — no create-path endpoint yet. Local mock for the UI. */
export const kairaKey = (mi: number, oi: number, foods: Food[], T: Targets) =>
  `${mi}-${oi}-${foods.length}-${Math.round(T.k)}`;

type KairaStatus = 'idle' | 'loading' | 'error' | 'done';
type Slot = { status: KairaStatus; data: KairaResponse | null };

const MOCK: KairaResponse = {
  mode: 'add',
  focus: 'fats',
  suggestions: [
    { name: 'almond', portion: '2.5 piece', k: 33, p: 1.1, c: 0.6, f: 2.9, why: 'Adds 2.9 g fats' },
    { name: 'Walnuts', portion: '1 number', k: 26, p: 0.6, c: 0.6, f: 2.6, why: 'Adds 2.6 g fats' },
    { name: 'sunflower seeds', portion: '1 teaspoon', k: 31, p: 1, c: 0.9, f: 2.6, why: 'Adds 1 g protein' },
    { name: 'Roasted Sunflower pumpkin & flax seeds (urban platter)', portion: '0.3 handful', k: 29, p: 1.3, c: 0.9, f: 2.6, why: 'Adds 1.3 g protein' },
    { name: 'Pumpkin Seeds (true elements)', portion: '0.5 spoon', k: 24, p: 0.7, c: 0.4, f: 2, why: 'Adds 0.7 g protein' },
  ],
};

export function useKaira() {
  const [byKey, setByKey] = useState<Record<string, Slot>>({});

  const forKey = useCallback((key: string): Slot => byKey[key] ?? { status: 'idle', data: null }, [byKey]);

  const ask = useCallback(async (key: string, _req: KairaRequest) => {
    setByKey(prev => ({ ...prev, [key]: { status: 'loading', data: prev[key]?.data ?? null } }));
    await new Promise(r => setTimeout(r, 350));
    setByKey(prev => ({ ...prev, [key]: { status: 'done', data: MOCK } }));
  }, []);

  return { forKey, ask };
}
